
import Typography from '@/ui-kit/components/typography';
import { TypographyType } from '@/ui-kit/components/typography/enums';
/**
 * @component HeaderComponent
 *
 * @prop {String} title
 * @prop {String} description
 * @private
 */
export default {
  name: 'HeaderComponent',
  components: {
    Typography,
  },
  props: {
    title: {
      type: String,
      default: '',
    },
    description: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      TypographyType,
    };
  },
};
